module.exports = function() {
  return new Worker(__webpack_public_path__ + "05be88a7b1fe738ae505.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/workers/savePdf.worker.js
// module id = 1283
// module chunks = 1